import { fetchLocalServices } from './apiClients/LocalhostApi';
import { getSessionStorage, getGlobal } from './apiClients/global';
export const CHIRP_SKIP_LOCAL_KEY = 'CHIRP_SKIP_LOCAL';
export const CHIRP_FORCE_401_KEY = 'CHIRP_FORCE_401';

// Extracts the workspace prefix from a local dev hostname.
// e.g. 'left.local.hubteamqa.com' → 'left', 'local.hubapiqa.com' → undefined
/** @visibleForTesting */
export function getWorkspaceFromHostname() {
  try {
    var _global$location$host, _global$location;
    const global = getGlobal();
    const hostname = (_global$location$host = (_global$location = global.location) === null || _global$location === void 0 ? void 0 : _global$location.hostname) !== null && _global$location$host !== void 0 ? _global$location$host : '';
    const labels = hostname.split('.');
    if (labels.length >= 4 && (labels[1] === 'local' || labels[1].startsWith('local-')) && /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/.test(labels[0])) {
      return labels[0];
    }
    return undefined;
  } catch (_unused) {
    return undefined;
  }
}
let localServicesPromise = null;

// we aren't allowed enviro here due to npm-shim constraints
function matchesLocation(hostnamePattern, pathPrefix) {
  try {
    const global = getGlobal();
    if (!global.location) {
      return false;
    }
    const {
      hostname,
      pathname
    } = global.location;
    return hostnamePattern.test(hostname) && (pathPrefix === undefined || pathname.startsWith(pathPrefix));
  } catch (_unused2) {
    return false;
  }
}
function isQA() {
  return matchesLocation(/qa\./);
}
function isGoggles() {
  return matchesLocation(/(tools|private|local)\.hubteam(qa)?\.com/, '/api');
}
function getSessionStorageFlag(key) {
  const sessionStorage = getSessionStorage();
  if (!sessionStorage || typeof sessionStorage.getItem !== 'function') {
    return false;
  }
  try {
    return sessionStorage.getItem(key) === 'true';
  } catch (_unused3) {
    return false;
  }
}
function getSkipLocalValue() {
  try {
    var _getSessionStorage;
    const raw = (_getSessionStorage = getSessionStorage()) === null || _getSessionStorage === void 0 ? void 0 : _getSessionStorage.getItem(CHIRP_SKIP_LOCAL_KEY);
    if (!raw) return null;
    if (raw === 'true') return true;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.every(i => typeof i === 'string') ? parsed : null;
  } catch (_unused4) {
    return null;
  }
}
function shouldSkipLocal(serviceName) {
  const value = getSkipLocalValue();
  if (value === true) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.includes(serviceName);
  }
  return false;
}
function fetchLocalServicesCached() {
  if (!localServicesPromise) {
    localServicesPromise = fetchLocalServices().catch(() => []);
  }
  return localServicesPromise;
}

/** Resets the local-services cache. Only for use in tests. */
export function _resetLocalServicesCacheForTesting() {
  localServicesPromise = null;
}
export async function resolveLocalRequest(serviceName, explicitLocalWorkspace) {
  const isAllowedHost = isQA() || isGoggles();
  if (!isAllowedHost) {
    return null;
  }
  if (shouldSkipLocal(serviceName)) {
    return null;
  }
  try {
    var _getWorkspaceFromHost, _matching$find;
    const services = await fetchLocalServicesCached();
    const matching = services.filter(s => s.name === serviceName);

    // explicitLocalWorkspace overrides everything (goggles use case):
    //   null  → explicitly route to the no-workspace service
    //   string → explicitly route to that workspace
    //   undefined → derive workspace from the page hostname
    const effectiveWorkspace = explicitLocalWorkspace !== undefined ? explicitLocalWorkspace // null or specific workspace string
    : (_getWorkspaceFromHost = getWorkspaceFromHostname()) !== null && _getWorkspaceFromHost !== void 0 ? _getWorkspaceFromHost : null; // hostname-derived, or null if no workspace

    const exactMatch = effectiveWorkspace !== null ? matching.find(s => s.workspace === effectiveWorkspace) : matching.find(s => !s.workspace);
    if (exactMatch) return exactMatch;

    // Fall back to the no-workspace service only for hostname-derived routing
    // (backwards compat: the no-workspace instance is the default when the
    // hostname workspace is not running locally). When the caller passed an
    // explicit workspace override (string or null), return null instead — the
    // caller explicitly named a workspace and silently routing to a different
    // service would mask misconfiguration.
    if (explicitLocalWorkspace !== undefined) return null;
    return (_matching$find = matching.find(s => !s.workspace)) !== null && _matching$find !== void 0 ? _matching$find : null;
  } catch (_unused5) {
    return null;
  }
}
export function shouldForce401() {
  return getSessionStorageFlag(CHIRP_FORCE_401_KEY);
}